import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IAdminProjectsDataContent } from '../../../../shared/interfaces/admin/admin.projects.data.content.interface';

@Component({
  selector: 'app-admin-favorites',
  templateUrl: './admin-favorites.component.html',
  styleUrls: ['./admin-favorites.component.sass']
})
export class AdminFavoritesComponent {
  @Output() sortOptions: EventEmitter<string> = new EventEmitter();
  @Output() dataSourceChangeInfinityScroll = new EventEmitter<number>();
  @Output() goTo = new EventEmitter<number>();
  @Output() createFavorite = new EventEmitter<number>();
  @Output() deleteFavorite = new EventEmitter<number>();
  @Output() copyEmitter = new EventEmitter();

  @Input() data: Array<IAdminProjectsDataContent>;
  @Input() currentSortOption: string;
  @Input() loading: boolean;
  @Input() noContentText: string;

  public displayedColumns =
        ['locked', 'key', 'title', 'costsAllocationText', 'lastExported', 'duplicateProject', 'favorite', 'goTo'];

  public onSortOptions(ev) {
    this.sortOptions.emit(ev);
  }

  public onDataSourceChangeInfinityScroll() {
    this.dataSourceChangeInfinityScroll.emit(3);
  }

  public onGoTo(ev: number) {
    this.goTo.emit(ev);
  }

  public onDeleteFavorite(projectId: number) {
    this.deleteFavorite.emit(projectId);
  }

  public onCreateFavorite(projectId: number) {
    this.createFavorite.emit(projectId);
  }

  public onCopy(ev) {
    this.copyEmitter.emit(ev);
  }
}
